import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Reconcilation.module.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import {
    Search,
    ChevronDown,
    MoreVertical,
    Filter,
    Bell
} from "lucide-react";
import TotalRunsIcon from "../../Assets/totalransactions.png"; 
import CompletedIcon from "../../Assets/reconciled.png";
import InProgressIcon from "../../Assets/unmatched.png";
import AttentionIcon from "../../Assets/openexceptions.png";
import CancelledIcon from "../../Assets/pendngapproval.png";
const ReconciliationRuns = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("total");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedAccount, setSelectedAccount] = useState("All Accounts");
    const [selectedStatus, setSelectedStatus] = useState("All Statuses");
    const [selectedPeriod, setSelectedPeriod] = useState("All Periods");

    const stats = [
        {
            label: "Total Runs",
            value: "48",
            subtitle: "All time",
            icon: TotalRunsIcon,
            color: "#6366f1"
        },
        {
            label: "Completed",
            value: "26",
            subtitle: "54.2%",
            icon: CompletedIcon,
            color: "#22c55e"
        },
        {
            label: "In Progress",
            value: "10",
            subtitle: "20.8%",
            icon: InProgressIcon,
            color: "#3b82f6"
        },
        {
            label: "Attention Required",
            value: "8",
            subtitle: "16.7%",
            icon: AttentionIcon,
            color: "#f59e0b"
        },
        {
            label: "Cancelled",
            value: "4",
            subtitle: "8.3%",
            icon: CancelledIcon,
            color: "#6b7280"
        },
    ];

    const tabs = [
        { id: "total", label: "Total Runs" },
        { id: "completed", label: "Completed" },
        { id: "inprogress", label: "In Progress" },
        { id: "attention", label: "Attention Required" },
        { id: "cancelled", label: "Cancelled" },
    ];

    const runsData = [
        {
            id: "RUN-08241",
            account: "GTBank Main Account",
            accountNumber: "GTB + 1234567890",
            bankTransactions: "18,420",
            ledgerTransactions: "18,210",
            matchRate: "98.2%",
            exceptions: "42",
            exceptionAmount: "₦840,000",
            status: "Completed",
            owner: "Adekunle O.",
            lastUpdated: "14 Aug. 2026",
            time: "10:31 AM"
        },
        {
            id: "RUN-08240",
            account: "Fidelity Account",
            accountNumber: "Fidelity + 1234567890",
            bankTransactions: "12,840",
            ledgerTransactions: "12,680",
            matchRate: "96.4%",
            exceptions: "86",
            exceptionAmount: "₦1,420,000",
            status: "In Progress",
            owner: "Agbakiska E.",
            lastUpdated: "14 Aug. 2026",
            time: "09:47 AM"
        },
        {
            id: "RUN-08239",
            account: "UBA Payments Account",
            accountNumber: "UBA + 12783767890",
            bankTransactions: "18,420",
            ledgerTransactions: "18,210",
            matchRate: "92.8%",
            exceptions: "124",
            exceptionAmount: "₦2,100,000",
            status: "Attention",
            owner: "Olaniregun B.",
            lastUpdated: "14 Aug. 2026",
            time: "09:42 AM"
        },
        {
            id: "RUN-08238",
            account: "Access Bank Account",
            accountNumber: "Access + 987654321",
            bankTransactions: "18,420",
            ledgerTransactions: "18,210",
            matchRate: "98.2%",
            exceptions: "42",
            exceptionAmount: "₦840,000",
            status: "Completed",
            owner: "Adekunle O.",
            lastUpdated: "14 Aug. 2026",
            time: "10:31 AM"
        },
        {
            id: "RUN-08237",
            account: "GTBank Main Account",
            accountNumber: "GTB + 1234567890",
            bankTransactions: "18,420",
            ledgerTransactions: "18,210",
            matchRate: "98.2%",
            exceptions: "42",
            exceptionAmount: "₦840,000",
            status: "Completed",
            owner: "Adekunle O.",
            lastUpdated: "14 Aug. 2026",
            time: "10:31 AM"
        },
        {
            id: "RUN-08236",
            account: "GTBank Main Account",
            accountNumber: "GTB + 1234567890",
            bankTransactions: "18,420",
            ledgerTransactions: "18,210",
            matchRate: "98.2%",
            exceptions: "42",
            exceptionAmount: "₦840,000",
            status: "Completed",
            owner: "Adekunle O.",
            lastUpdated: "14 Aug. 2026",
            time: "10:31 AM"
        }
    ];

    const getStatusColor = (status) => {
        switch (status) {
            case "Completed": return "#22c55e";
            case "In Progress": return "#3b82f6";
            case "Attention": return "#f59e0b";
            default: return "#6b7280";
        }
    };

    const getStatusDot = (status) => {
        return <span className={classes.statusDot} style={{ backgroundColor: getStatusColor(status) }}></span>;
    };

    return (
        <div className={classes.page}>
            <Header />
            <Sidebar />

            <main className={classes.main}>
                <div className={classes.container}>
                    <div className={classes.headerSection}>
                        <div>
                            <h1 className={classes.title}>Reconciliation Runs</h1>
                            <p className={classes.subtitle}>Create, monitor and manage all your reconciliation runs in one place</p>
                        </div>
                        <button className={classes.createButton}
                            onClick={() => navigate("/Reconcilation/NewReconciliationRun")}
                        >
                            + New Reconcilation Run
                        </button>
                    </div>

                    {/* Stats Cards with Local Images */}
                    <div className={classes.statsGrid}>
                        {stats.map((stat, index) => (
                            <div key={index} className={classes.statCard}>
                                <div className={classes.statIcon} >
                                    <img 
                                        src={stat.icon} 
                                        alt={stat.label} 
                                        className={classes.statImage}
                                    />
                                </div>
                                <div className={classes.statInfo}>
                                    <div className={classes.statLabel}>{stat.label}</div>
                                    <div className={classes.statValue}>{stat.value}</div>
                                    <div className={classes.statSubtitle}>{stat.subtitle}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Filters */}
                    <div className={classes.filtersSection}>
                        <div className={classes.searchWrapper}>
                            <Search size={18} className={classes.searchIcon} />
                            <input
                                type="text"
                                placeholder="Search by account, run..."
                                className={classes.searchInput}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        <div className={classes.filters}>
                            <div className={classes.filterDropdown}>
                                <select
                                    className={classes.filterSelect}
                                    value={selectedAccount}
                                    onChange={(e) => setSelectedAccount(e.target.value)}
                                >
                                    <option>All Accounts</option>
                                    <option>GTBank Main Account</option>
                                    <option>Fidelity Account</option>
                                    <option>UBA Payments Account</option>
                                    <option>Access Bank Account</option>
                                </select>
                                <ChevronDown size={16} className={classes.dropdownIcon} />
                            </div>

                            <div className={classes.filterDropdown}>
                                <select
                                    className={classes.filterSelect}
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option>All Statuses</option>
                                    <option>Completed</option>
                                    <option>In Progress</option>
                                    <option>Attention</option>
                                    <option>Cancelled</option>
                                </select>
                                <ChevronDown size={16} className={classes.dropdownIcon} />
                            </div>

                            <div className={classes.filterDropdown}>
                                <select
                                    className={classes.filterSelect}
                                    value={selectedPeriod}
                                    onChange={(e) => setSelectedPeriod(e.target.value)}
                                >
                                    <option>All Periods</option>
                                    <option>Today</option>
                                    <option>This Week</option>
                                    <option>This Month</option>
                                    <option>This Quarter</option>
                                </select>
                                <ChevronDown size={16} className={classes.dropdownIcon} />
                            </div>

                            <button className={classes.moreFiltersBtn}>
                                <Filter size={16} />
                                More Filters
                            </button>
                        </div>
                    </div>

                    {/* Transactions Header with Attention Button */}
                    <div className={classes.transactionsHeader}>
                        <h2 className={classes.transactionsTitle}>Transactions</h2>
                        <button className={classes.attentionBtn}>
                            <span className={classes.attentionDot}></span>
                            <span>10 needs Attention</span>
                        </button>
                    </div>

                    {/* Table */}
                    <div className={classes.tableContainer}>
                        <table className={classes.table}>
                            <thead>
                                <tr>
                                    <th>Run</th>
                                    <th>Account</th>
                                    <th>Transactions Bank / Ledger</th>
                                    <th>Match Rate</th>
                                    <th>Exceptions</th>
                                    <th>Status/ Owner</th>
                                    <th>Last Updated</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {runsData.map((run, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className={classes.runId}>{run.id}</div>
                                            <div className={classes.runDate}>01-14 Aug 2026</div>
                                        </td>
                                        <td>
                                            <div className={classes.accountName}>{run.account}</div>
                                            <div className={classes.accountNumber}>{run.accountNumber}</div>
                                        </td>
                                        <td>
                                            <div className={classes.transactions}>
                                                {run.bankTransactions} / {run.ledgerTransactions}
                                            </div>
                                        </td>
                                        <td>
                                            <div className={classes.matchRate}>
                                                <span className={classes.matchValue}>{run.matchRate}</span>
                                                <div className={classes.matchBar}>
                                                    <div
                                                        className={classes.matchBarFill}
                                                        style={{
                                                            width: run.matchRate,
                                                            backgroundColor: parseFloat(run.matchRate) > 95 ? "#22c55e" : parseFloat(run.matchRate) > 90 ? "#f59e0b" : "#ef4444"
                                                        }}
                                                    ></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className={classes.exceptions}>
                                                <span className={classes.exceptionCount}>{run.exceptions}</span>
                                                <span className={classes.exceptionAmount}>{run.exceptionAmount}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className={classes.statusOwner}>
                                                <div className={classes.status}>
                                                    {getStatusDot(run.status)}
                                                    <span>{run.status}</span>
                                                </div>
                                                <div className={classes.owner}>{run.owner}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className={classes.lastUpdated}>
                                                <div>{run.lastUpdated}</div>
                                                <div className={classes.time}>{run.time}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <button className={classes.actionButton}>
                                                <MoreVertical size={18} />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className={classes.pagination}>
                        <span className={classes.paginationInfo}>Showing 1 to 6 of 48 runs</span>
                        <div className={classes.paginationControls}>
                            <button className={classes.pageButton} disabled>Previous</button>
                            <button className={`${classes.pageButton} ${classes.activePage}`}>1</button>
                            <button className={classes.pageButton}>2</button>
                            <button className={classes.pageButton}>3</button>
                            <button className={classes.pageButton}>...</button>
                            <button className={classes.pageButton}>8</button>
                            <button className={classes.pageButton}>Next</button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ReconciliationRuns;